import { useState } from "react";
import TaskForm from "./TaskForm";
import TaskList from "./TaskList";
import { AnimatePresence, motion } from "motion/react"
import './Task.css';

const Task = () => {
  const [tasks, setTasks] = useState([]);
  const [isFormShown, setIsFormShown] = useState(false);

  const addTask = (task) => setTasks((prev) => [...prev, task]);
  const isFormShow = () => {
    setIsFormShown(!isFormShown);
  }

  return (
    <div className="task-form">
      <h1 className="text-white">Task Assignment Dashboard</h1>
      <button type="button" onClick={isFormShow}>{!isFormShown ? 'Add Task' : 'Close'}</button>
      <AnimatePresence>
        {isFormShown ? <motion.div key="box" exit={{ opacity: 0 }} >
          <TaskForm onAddTask={addTask} />
        </motion.div> : null}
      </AnimatePresence>
      <TaskList tasks={tasks} />
    </div>
  );
};

export default Task;
